export default __webpack_public_path__ + "static/media/tab_ico.d2abf85c.svg";